import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <circle cx="36.5" cy="36.5" r="35.4265" stroke="white" strokeWidth="2.14706" />
    <path
      clipRule="evenodd"
      d="M27.9156 57.9595V30.4166L18.9707 31.9069C17.9354 32.0793 17.1765 32.9751 17.1765 34.0247V55.7391C17.1765 56.9178 18.1267 57.8761 19.3053 57.8861L27.9156 57.9595ZM49.3939 57.9705H30.0634L30.0635 30.0587L34.5226 8.58813H35.1021C38.1746 8.58816 41.2324 11.4163 41.2324 14.5721L40.8026 27.9117H53.6895C57.5413 27.9117 60.836 30.1583 59.9813 34.0158L55.759 53.0719C55.1374 55.8774 52.1951 57.9705 49.3939 57.9705Z"
      fill="white"
      fillRule="evenodd"
    />
  </>,
  'Super',
)
